<template>
  <main>
    <div class="navbar-fixed">
      <nav>
        <div class="nav-wrapper center-align">
          <img class="logo-navbar " src="../assets/recargate.png"/>
        </div>
      </nav>
    </div>
    <div class="row">
      <div class="col s10 m8 l6 offset-s1 offset-m2 offset-l3">
        <div class="card-panel center-align">
          <span class="titulo-card">
            No olvides la empresa en la URL
          </span>

        </div>
      </div>
    </div>
  </main>
</template>

<script>
  import {iniciarSesion} from '@/api/api'
  import {mapState} from 'vuex'


  export default {
    name: "login",
    data() {
      return {
        msg: '',
        usuario: '',
        password: '',
      }
    },
    methods: {
    },
    mounted() {
      const dominio = window.location.href
      if (dominio.includes('herramientasbaevi.com')) this.$router.push({name: 'login', params:{empresa:'login'}})
      else if (dominio.includes('gmcel.com')) this.$router.push({name: 'login', params:{empresa:'login'}})
      else if (dominio.includes('gruposima.mx')) this.$router.push({name: 'login', params:{empresa:'login'}})
      else if (dominio.includes('enlaceshop.com')) this.$router.push({name: 'login', params:{empresa:'login'}})
      else if (dominio.includes('recargastgmex.mx')) this.$router.push({name: 'login', params:{empresa:'login'}})
      else if (dominio.includes('recargasgsmoviles.com.mx')) this.$router.push({name: 'login', params:{empresa:'login'}})
      else if (dominio.includes('recargasasec.com')) this.$router.push({name: 'login', params:{empresa:'login'}})
      else if (dominio.includes('recargasdraggomovil.com')) this.$router.push({name: 'login', params:{empresa:'login'}})
      else if (dominio.includes('leiphone.com.mx')) this.$router.push({name: 'login', params:{empresa:'login'}})
      else if (dominio.includes('damtel')) this.$router.push({name: 'login', params:{empresa:'login'}})
      else if (dominio.includes('recargaszaz.com.mx')) this.$router.push({name: 'login', params:{empresa:'login'}})
      else if (dominio.includes('cmtex.com.mx')) this.$router.push({name: 'login', params:{empresa:'login'}})
      else if (dominio.includes('activasimrecargas.com')) this.$router.push({name: 'login', params:{empresa:'login'}})
      else if (dominio.includes('simcroft')) this.$router.push({name: 'login', params:{empresa:'login'}})
      else if (dominio.includes('innova')) this.$router.push({name: 'login', params:{empresa:'login'}})
      else if (dominio.includes('discovery')) this.$router.push({name: 'login', params:{empresa:'login'}})
      else if (dominio.includes('devsol')) this.$router.push({name: 'login', params:{empresa:'login'}})
      else if (dominio.includes('tridial')) this.$router.push({name: 'login', params:{empresa:'login'}})
      else if (dominio.includes('movicell')) this.$router.push({name: 'login', params:{empresa:'login'}})
      else if (dominio.includes('todosim')) this.$router.push({name: 'login', params:{empresa:'login'}})
      else if (dominio.includes('eradigital')) this.$router.push({name: 'login', params:{empresa:'login'}})
      else if (dominio.includes('silverphone')) this.$router.push({name: 'login', params:{empresa:'login'}})
      else if (dominio.includes('celstar')) this.$router.push({name: 'login', params:{empresa:'login'}})
      else if (dominio.includes('vam')) this.$router.push({name: 'login', params:{empresa:'login'}})
      else if (dominio.includes('aba')) this.$router.push({name: 'login', params:{empresa:'login'}})
    },
    computed: {
      ...mapState(['accentColor'])
    }
  }
</script>

<style scoped>
  .navbar-fixed {
    margin-top: -5px;
  }

  nav {
    background-color: white !important;
  }

  .logo-navbar {
    max-height: 80%;
    margin-top: 10px;
  }


  .titulo-card {
    font-size: 2.3em;
    position: relative;
    font-family: "Roboto Light", sans-serif;
  }

  .card-panel{
    margin-top: 50px;
  }


</style>
